import axios from 'axios'
import cfg from "./config"

const TOKEN_KEY = '__hidroview__access_token'
const REFRESH_TOKEN_KEY = '__hidroview__refresh_token'
const PERSIST_CONNECT = '__hidroview__persist_connect'
const USER_INFO = '__hidroview__me'

const parse = JSON.parse
const stringify = JSON.stringify

const auth = {
    clear(key) {
        if (localStorage && localStorage.getItem(key)) {
            return localStorage.removeItem(key)
        }

        if (sessionStorage && sessionStorage.getItem(key)) {
            return sessionStorage.removeItem(key)
        }

        return null
    },

    clearAppStorage(reload = false) {
        if (localStorage) {
            localStorage.clear()
        }

        if (sessionStorage) {
            sessionStorage.clear()
        }

        if (reload) {
            window.location.reload()
        }
    },

    clearToken(tokenKey = TOKEN_KEY) {
        return auth.clear(tokenKey)
    },

    clearUserInfo(userInfo = USER_INFO) {
        return auth.clear(userInfo)
    },

    clearUserOrigin() {
        return auth.clear('__hidroview__userOrigin')
    },

    isPai () {
        const data = this.getUserInfo()
        return data.empresa_tipo === "Revenda"
    },

    isClient() {
        let tipo = this.getUserInfo()?.tipo
        return tipo == "cliente"
    },

    isMasterOrAdmin() {
        let tipo = this.getUserInfo()?.tipo
        if (!tipo) return false

        return ["admin", "master"].includes(tipo)
    },

    get(key) {
        if (localStorage && localStorage.getItem(key)) {
            return parse(localStorage.getItem(key)) || null
        }

        if (sessionStorage && sessionStorage.getItem(key)) {
            return parse(sessionStorage.getItem(key)) || null
        }

        return null
    },

    getToken(tokenKey = TOKEN_KEY) {
        return auth.get(tokenKey)
    },

    getUserInfo(userInfo = USER_INFO) {
        return auth.get(userInfo)
    },

    set(value, key, isLocalStorage) {
        if (value.toString().length == 0) {
            return null
        }

        if (isLocalStorage && localStorage) {
            return localStorage.setItem(key, stringify(value))
        }

        if (sessionStorage) {
            return sessionStorage.setItem(key, stringify(value))
        }

        return null
    },

    setToken(value = '', isLocalStorage = false, tokenKey = TOKEN_KEY) {
        return auth.set(value, tokenKey, isLocalStorage)
    },

    setUserInfo(value = '', isLocalStorage = false, userInfo = USER_INFO) {
        return auth.set(value, userInfo, isLocalStorage)
    },

    setUserOrigin(value = '') {
        return auth.set(value, '__hidroview__userOrigin', true)
    },

    setChangedEmpresa(value=null){
        return auth.set(value, '__afira__changedEmpresa', true)
    },

    getChangedEmpresa(){
        return auth.get('__afira__changedEmpresa')
    },

    removeChangedEmpresa(){
        return auth.clear('__afira__changedEmpresa')
    },

    refreshPromise: null,

    async refreshToken() {
        if (this.refreshPromise) {
            return this.refreshPromise
        }

        this.refreshPromise = this.doRefreshToken().finally(() => {
            this.refreshPromise = null
        })

        return this.refreshPromise
    },

    async doRefreshToken() {
        try {
            let persistConnection = JSON.parse(localStorage.getItem(PERSIST_CONNECT))
            let refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY)

            if (persistConnection === "true" && refreshToken != null) {
                await axios({
                    method: "POST",
                    url: cfg.base_api_url + "o/token/",
                    data: {
                        "client_id": cfg.client_id,
                        "client_secret": cfg.client_secret,
                        "grant_type": "refresh_token",
                        "refresh_token": JSON.parse(refreshToken)
                    },
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                }).then(async (res) => {
                    this.setToken(res.data.access_token, true)
                    this.set(res.data.refresh_token, REFRESH_TOKEN_KEY, true)
                    this.set("true", PERSIST_CONNECT, true)
                    window.location.reload()
                }, (err) => console.error(err))
            } else {
                this.clearAppStorage(true)
            }
        } catch (err) {
            this.clearAppStorage(true)
        }
    }
}

export default auth